(function () {
    'use strict';

    angular
        .module('directives.govAutoFocus', [])
        .directive('govAutoFocus', directive);

    directive.$inject = ['$timeout'];

    function directive($timeout) {
        return {
            restrict: 'A',
            link: function(scope, elem){
                $timeout(function () {
                    elem[0].focus();
                }, 100);
                // delayed 100ms as in some cases the element wouldn't focus
                // might be timing issue while opening the modal
            }
        };
    }
})();